import React from 'react';
import styles from './beatLoader.module.scss';

export default function BeatLoader({ color }: { color?: string }) {
  return <div className={styles.loader} style={color ? { color } : {}}></div>;
}
